export default [
  {
      path:"/animals",
      name:"Animals-list",
      component: () => import("@/components/adm/animals/AnimalsList.vue"),
      meta: {
        title: "Cadastro > Animais"
      }
  },
]